import { Service, inject } from '@angular/core'
import {
  JoinPublicReservationBody,
  Reservation,
  GetReservationActivitiesResponse,
  GetPublicEntityReservationSlotsQuery,
  GetReservationSlotsResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class PublicEntityReservationApiService {
  private readonly api = inject(ApiService)

  createReservation(entityId: string, body: JoinPublicReservationBody, init?: RequestInit) {
    return this.api.fetchJson<Reservation>(`entities/${entityId}/reservations`, {
      body: JSON.stringify(body),
      method: 'POST',
      ...init,
    })
  }

  getReservationActivities(entityId: string, init?: RequestInit) {
    return this.api.fetchJson<GetReservationActivitiesResponse>(
      `entities/${entityId}/reservations/reservation-activities`,
      { ...init },
    )
  }

  getReservationSlots(entityId: string, query: GetPublicEntityReservationSlotsQuery, init?: RequestInit) {
    const url = this.api.createURL(`entities/${entityId}/reservations/reservation-slots`)
    url.search = this.api.toQueryParams(query)
    return this.api.fetchJson<GetReservationSlotsResponse>(url, { ...init })
  }
}
